import { BackSide, Mesh, TextureLoader, Vector3 } from 'three';
import { MeshProps, useLoader } from '@react-three/fiber';
import React, { useCallback, useEffect, useRef } from 'react';

interface PanoSphereProps extends MeshProps {
  texturePath: string;
  onTextureLoaded?: () => void;
  onTextureUnloaded?: () => void;
}

const PanoSphere: React.FC<PanoSphereProps> = ({
  texturePath,
  onTextureLoaded,
  onTextureUnloaded,
  ...props
}) => {
  const texture = useLoader(TextureLoader, texturePath);
  useEffect(() => {
    const loadedTexture = texture;
    if (loadedTexture) onTextureLoaded?.();
    return () => {
      if (loadedTexture) onTextureUnloaded?.();
    };
  }, [onTextureLoaded, onTextureUnloaded, texture]);

  const meshRef = useRef<Mesh>(null);

  const handleOnPointerDown = useCallback((e) => {
    if (e.button !== 0) return;
    // If in development, log the hit direction
    if (process.env.NODE_ENV !== 'development') return;
    const { x, y, z } = e.point;
    const hitDir = new Vector3(x, y, z).normalize();
    const fixedX = hitDir.x.toFixed(4);
    const fixedY = hitDir.y.toFixed(4);
    const fixedZ = hitDir.z.toFixed(4);
    console.log(`Hit direction (${fixedX}, ${fixedY}, ${fixedZ})`);
  }, []);

  return (
    <mesh
      {...props}
      ref={meshRef}
      scale={[-1, 1, 1]}
      onPointerDown={handleOnPointerDown}
    >
      <sphereBufferGeometry args={[100, 60, 60]} />
      <meshBasicMaterial map={texture} side={BackSide} />
    </mesh>
  );
};
export default PanoSphere;
